import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useMenuLabel } from '@/lib/menu-labels';
import ComingSoonPage from '@/pages/ComingSoonPage';

const ShopComingSoonPage: React.FC = () => {
  const { t } = useTranslation();
  const menuLabel = useMenuLabel();

  return (
    <ComingSoonPage
      label={menuLabel('shop', t.shop?.comingSoonLabel || 'Online Shop')}
      title={t.shop?.comingSoonTitle || 'Coming\nSoon'}
      subtitle={t.shop?.comingSoonSubtitle || 'Our curated collection of fine art photography is being prepared. A timeless selection — soon to be unveiled.'}
    />
  );
};

export default ShopComingSoonPage;
